// Single source of truth for the frontend version.
// Anything that displays a version reads from THIS module.
// Bumping the version is a one-line change here plus a new CHANGELOG block.
// Backend has an equivalent at `backend/__version__.py`.

export const APP_VERSION = "1.6.1";
export const APP_CODENAME = "V1.6 Scale";
